import { createSlice } from "@reduxjs/toolkit";

export const careerSlice = createSlice({
  name: "career",
  initialState: {
    list: [],
  },
  reducers: {
    setCareer: (state, action) => {
      console.log("setCareer", action.payload);
      state.list = action.payload.list;
    },
  },
});

export const { setCareer } = careerSlice.actions;

export default careerSlice.reducer;
